import React from "react";

const VanIcon = ({ width = 48, height = 48, stroke = "white" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 36V12C28 10.9391 27.5786 9.92172 26.8284 9.17157C26.0783 8.42143 25.0609 8 24 8H8C6.93913 8 5.92172 8.42143 5.17157 9.17157C4.42143 9.92172 4 10.9391 4 12V34C4 34.5304 4.21071 35.0391 4.58579 35.4142C4.96086 35.7893 5.46957 36 6 36H10"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 36H18"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38 36H42C42.5304 36 43.0391 35.7893 43.4142 35.4142C43.7893 35.0391 44 34.5304 44 34V26.7C43.9992 26.2461 43.844 25.806 43.56 25.452L36.6 16.752C36.4129 16.5178 36.1756 16.3286 35.9056 16.1984C35.6356 16.0682 35.3398 16.0004 35.04 16H28"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 40C36.2091 40 38 38.2091 38 36C38 33.7909 36.2091 32 34 32C31.7909 32 30 33.7909 30 36C30 38.2091 31.7909 40 34 40Z"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 40C16.2091 40 18 38.2091 18 36C18 33.7909 16.2091 32 14 32C11.7909 32 10 33.7909 10 36C10 38.2091 11.7909 40 14 40Z"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VanIcon;
